<template>
  <div id="zones">
    <Title title="Zonas de Restricción"
           subtitle="Crea, activa, desactiva y elimina zonas"/>
    <FilterMapModify :open="form.open">
      <ZonesFormModify
                 ref="zoneForm"
                 slot="form"
                 :polygon="polygon"
                 @addPoligon="addPoligon"
                 @centerMap="centerMap"
                 @submit="receivePolygonTable"
                 @cleanPoly="cleanPolygonMap"
                 @clickSendZone="clickSendZone"
                 @changePoligonState="changeStatePoligon"></ZonesFormModify>
      <el-button slot="button"
                 class="btn primary"
                 @click="form.open = !form.open">
        <i v-if="form.open" class="fas fa-angle-left"></i>
        <i v-else class="fa fa-plus"></i>
      </el-button>
      <MapZonesModify ref="map" slot="map"
                @submit="receivePolygon"
                @getPolygonPath="getPolygonPath"></MapZonesModify>
    </FilterMapModify>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import FilterMapModify from '../components/maps/FilterMapModify.vue';
import MapZonesModify from '../components/maps/MapZonesModify.vue';
import ZonesFormModify from '../components/ZonesFormModify.vue';

export default {
  name: 'ZonesModify',
  components: {
    Title,
    FilterMapModify, // ok
    MapZonesModify, // ok
    ZonesFormModify, // ok
  },
  data() {
    return {
      form: {
        open: true,
        type: '',
      },
      polygon: '',
    };
  },
  methods: {
    receivePolygonTable(data) {
      this.$refs.map.updatePath(data);
    },
    receivePolygon(data) {
      this.polygon = data;
    },
    addPoligon(edit) {
      this.$refs.map.newPath(edit);
    },
    changeStatePoligon(editable) {
      this.$refs.map.changeStatePoligon(editable);
    },
    cleanPolygonMap() {
      this.$refs.map.deleteSelectedShape();
    },
    centerMap(lng, lat, zoom) {
      this.$refs.map.centerMap(lng, lat, zoom);
    },
    clickSendZone() {
      this.$refs.map.getPolygonPath();
    },
    getPolygonPath(data) {
      this.polygon = data;
      this.$refs.zoneForm.sendZone(data);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
